<cwc-picker (cwcChange)="onJobsiteChange($event.detail)" unwrap filter data-testid="jobsite-selection" variant="header"
  required design-version="v2" [placeholder]="jobsitesPlaceholder" [filterPlaceholder]="searchPlaceholder"
  [filterEmptyMessage]="searchEmptyMessage" [emptyMessage]="emptyMessage" [label]="jobsitesPlaceholder">
  <cwc-picker-option *ngFor="
      let jobsite of jobsites$ | async;
      trackBy: 'id' | cwcTrackBy;
      let i = index
    " [value]="jobsite.id" [selected]="i === 0">
    {{ jobsite.name }}
  </cwc-picker-option>
</cwc-picker>